import React, { Component } from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import { Form } from "react-bootstrap"
import isEqual from 'lodash/isEqual'
import "../../../../styles/css/DropDownCheckbox.css";

export default class ContractPicker extends Component {
    constructor(props){
        super(props)
        this.state = {
            data: props.data,
            labelText: props.labelText
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if(!isEqual(nextProps.data, this.state)) {
            this.setState({ data: nextProps.data })
        }
    }

    shouldComponentUpdate = (nextProps) => {
        return !isEqual(nextProps.data, this.state)
    }
    
    render() {
        const { data, ...rest } = this.props
        return (
            <>
                <Form.Label>{ this.state.labelText }</Form.Label>
                <DropdownTreeSelect data={ this.state.data } { ...rest } />
            </>
        )
    }
}